var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMotif16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 15.9955,
    viewBox: "0 0 16 15.9955",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 161"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.00003 0C12.4183 0 16 3.58072 16 7.99767C16 12.4146 12.4183 15.9953 8.00003 15.9953C3.58179 15.9953 2.70605e-05 12.4146 2.70605e-05 7.99767C2.70605e-05 3.58072 3.58179 0 8.00003 0Z",
    fill: "#D4623A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.08279 3.58517C10.5356 3.58517 12.5242 5.57311 12.5242 8.02525C12.5242 10.4774 10.5356 12.4653 8.08279 12.4653C5.62994 12.4653 3.64141 10.4774 3.64141 8.02525C3.64141 5.57311 5.62994 3.58517 8.08279 3.58517Z",
    fill: "#274766"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotif16);
export default __webpack_public_path__ + "static/media/motif-16.de02c98645f6d5cea4dae1e1194ea033.svg";
export { ForwardRef as ReactComponent };